import React from 'react';

import ProjectReports from './ProjectReports';
import { useProject } from '../../hooks/useProject';
import { ProjectPage } from './ProjectPage';
import { FormBase } from '../Interface';

export const ProjectMain = (props) => {
  const projectState = useProject();
  const projectPage = <ProjectPage {...props} projectState={projectState} />;

  if (props.hideRightPanel) {
    return projectPage;
  }

  return (
    <FormBase
      name="project"
      leftPanelContent={projectPage}
      rightPanelContent={<> {!projectState.isLoading && <ProjectReports projectState={projectState} />}</>}
    />
  );
};
